import React from 'react';
import { StudyPlanSettingsPanelProps } from './types';
import ExpansionPanel, { ExpansionPanelGroup } from '@magoosh/gre/adaptive_prep_v2/lib/expansion_panel';
import StudyPlanSettingsForm from '@magoosh/gre/adaptive_prep_v2/organisms/study_plan_settings_form';

export const PlanSettingsPanel: React.FC<StudyPlanSettingsPanelProps> = (props) => {
  const { onSubmit, currentSettings, presetPlanOptions, planType } = props;

  return (
    <>
      <ExpansionPanelGroup>
        {currentSettings && (
          <ExpansionPanel
            text="Change"
            title={
              <span className="d-flex justify-content-between align-items-center">
                <h4>
                  <strong>Study Plan Settings</strong>
                </h4>
              </span>
            }>
            {(onClose) => (
              <StudyPlanSettingsForm
                planType={planType}
                currentSettings={currentSettings}
                presetPlanOptions={presetPlanOptions}
                onClose={onClose}
                onSubmit={onSubmit}
              />
            )}
          </ExpansionPanel>
        )}
      </ExpansionPanelGroup>
    </>
  );
};

export default PlanSettingsPanel;
